/* -----  stellarsky.solutions edits starts here ------ */
function initSskyCardPointer() {
  document.querySelectorAll(".ssky-card-wrapper").forEach(function (item) {
    const sskycPointer = item.querySelector(".ssky-card-pointer");
    if (!sskycPointer) return;

    // Remove previous listeners to avoid stacking
    item.onmousemove = null;
    item.onmouseleave = null;
    item.onmouseenter = null;

    item.addEventListener("mousemove", function (e) {
      const rect = item.getBoundingClientRect();
      let x = e.clientX - rect.left - sskycPointer.offsetWidth / 2;
      let y = e.clientY - rect.top - sskycPointer.offsetHeight / 2;
      x = Math.max(0, Math.min(x, rect.width - sskycPointer.offsetWidth));
      y = Math.max(0, Math.min(y, rect.height - sskycPointer.offsetHeight));
      sskycPointer.style.left = x + "px";
      sskycPointer.style.top = y + "px";
    });
    item.addEventListener("mouseleave", function () {
      sskycPointer.style.opacity = 0;
    });
    item.addEventListener("mouseenter", function () {
      sskycPointer.style.opacity = 1;
    });
  });
}
/* -----  stellarsky.solutions edits completes here ------ */
